import { BoundRadioGroup } from "lib/@components/binding/bound-components"
import { Repeat } from "lib/@components/repeat"
import { RequestedFieldChoiceOption } from "./requested-field-choice-option"

/**
 * Recipient input for a `choice` requested field. Radio group bound to `values.<field.id>`, with one
 * option per entry in `field.options` rendered via `<Repeat>` (no inline closure components).
 *
 * @param {object} props
 * @param {{ id: string, options?: string[] }} props.field
 */
export function ChoiceFieldInput({ field }) {
    return (
        <BoundRadioGroup field={`values.${field.id}`} row noLabel>
            <Repeat list={getOptions()} pass="option" item={<RequestedFieldChoiceOption />} />
        </BoundRadioGroup>
    )

    function getOptions() {
        return Array.isArray(field.options) ? field.options : []
    }
}
